<template>
	<div
		v-if="isBlockShown"
		id="programm_announces"
		:class="
			'panel programms ' +
				(isHeaderIndent ? ' mt-0 pt-0 ' : '') +
				(isFooterIndent ? ' mb-0 pb-0 ' : '') +
				block.appearance
		"
	>
		<div>
			<div class="container">
				<div
					v-if="isHeaderVisible"
					:class="'panel_header' + (isBrand ? ' sk' : '')"
				>
					<PanelThemesHeader
						:title="block.block_title"
						:description="block.description"
						:prop-active-tab="TABS_ID.PROGRAMMES"
						@updateRecommendationsData="handleRecommendationsData"
					>
						<template #link-button>
							<ArrowButton url="/navigator/programmes/" class="d-none d-lg-block">
								Все программы
							</ArrowButton>
							<span class="d-flex d-lg-none title mb-0 icon-chevron-thin-right" />
						</template>
						<template #tags>
							<a
								class="btn btn-outline-primary mr-1 mr-md-3 mt-2"
								href="/corporate/"
								target="_blank"
							>
								Кастомизированные образовательные программы для компаний
							</a>
						</template>
					</PanelThemesHeader>
				</div>
				<ListWithMobileSlider
					desktop-class="programms_list row d-none d-md-flex"
					desktop-list-class="col-12 col-md-6 col-xl-4"
					mobile-class="row d-flex d-md-none"
					:items-list="getDynamicDataWithTags(block.events)"
				>
					<template #default="{ item }">
						<EventCard
							v-if="item"
							:event="item"
							:block="block"
							:is-alumni="isAlumni"
							:image="getImageEvent(item)"
						/>
					</template>
				</ListWithMobileSlider>
			</div>
		</div>
		<component :is="'script'" type="application/ld+json">
			{{ jsonld }}
		</component>
	</div>
</template>
<script>
import '@/utils/moment';

import { directive } from 'vue-awesome-swiper';

import { TYPOLOGY } from '@/utils/dictionaries';
import { mapActions } from 'vuex';
import checkIsBlockShown from '~/mixins/checkIsBlockShown';
import EventCard from '~/components/cards/EventCard.vue';
import ArrowButton from '~/components/buttons/ArrowButton.vue';
import PanelThemesHeader from '~/components/panels/system/PanelThemesHeader.vue';
import recommendationTags from '~/mixins/recommendationTags';
import ListWithMobileSlider from '~/components/ListWithMobileSlider.vue';

export default {
	name: 'PanelProgrammsV2',
	components: {
		ListWithMobileSlider,
		PanelThemesHeader,
		ArrowButton,
		EventCard,
	},
	directives: {
		swiper: directive,
	},
	mixins: [checkIsBlockShown, recommendationTags],
	props: {
		block: { type: Object, required: true },
		fetchedData: { type: Object, required: true },
	},
	data() {
		return {
			options: {
				slidesPerView: 'auto',
				spaceBetween: 0,
				// freeMode: true,
				loop: false,
			},
			TYPOLOGY,
		};
	},
	computed: {
		jsonld() {
			const schema = {
				'@context': 'https://schema.org',
				'@type': 'ItemList',
				itemListElement: this.block.events.map((el, index) => ({
					'@type': 'ListItem',
					position: index + 1,
					url: el.frontend_url,
				})),
			};
			return schema;
		},
		isHeaderVisible() {
			return this.block.display_header === 1;
		},
		isHeaderIndent() {
			return this.block.hide_top_indent === 1;
		},
		isFooterVisible() {
			return this.block.display_footer === 1;
		},
		isFooterIndent() {
			return this.block.hide_bottom_indent === 1;
		},
		isBrand() {
			return this.block.display_brand_background === 1;
		},
	},
	methods: {
		...mapActions({
			showLoginPopup: 'authModal/showLogin',
		}),
		getImageEvent(event) {
			const { listing_cover_image_default, top_cover_image_default } = event || {};
			const image = (!!listing_cover_image_default?.length && listing_cover_image_default)
				|| top_cover_image_default;
			return image?.src || '';
		},
	},
};
</script>
<style lang="scss" scoped>
//@import "~/assets/styles/components/home/panel-programms";
@import "assets/styles/sk_variables";
// For use bootstrap vars and mixins inside
@import "assets/styles/bootstrap/scss/functions";
@import "assets/styles/bootstrap/scss/variables";
@import "assets/styles/bootstrap/scss/mixins";

.programms_list {
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
}
</style>
